import { useEffect, useState } from "react";
import Button from "../../Components/Button";
import {
  IApplyOptionProgress,
  ProgressType,
} from "../../Interfaces/applyOption";
import {
  getProgressByType,
  submitApplyRemainingOptionRequest,
  traceAppliedRemainingOptionRequest,
  updatePortfoStatus,
  updateTradingBooksStatus,
} from "../../Requests/applyOption";
import { toast } from "react-toastify";
import { packetErrorHandler } from "../../Utils/requestUtils";

interface IProps {
  refreshActiveTable: () => void;
}

const StatusesBox = ({ refreshActiveTable }: IProps) => {
  const [portfoStatus, setPortfoStatus] = useState({} as IApplyOptionProgress);
  const [tradingBooksStatus, setTradingBooksStatus] = useState(
    {} as IApplyOptionProgress,
  );
  const [applyRemainingOptionStatus, setApplyRemainingOptionStatus] = useState(
    {} as IApplyOptionProgress,
  );
  const [
    traceAppliedRemainingOptionStatus,
    setTraceAppliedRemainingOptionStatus,
  ] = useState({} as IApplyOptionProgress);
  const [portfoStatusLoading, setPortfoStatusLoading] = useState(false);
  const [tradingBooksStatusLoading, setTradingBooksStatusLoading] =
    useState(false);
  const [
    applyRemainingOptionStatusLoading,
    setApplyRemainingOptionStatusLoading,
  ] = useState(false);
  const [
    traceAppliedRemainingOptionStatusLoading,
    setTraceAppliedRemainingOptionStatusLoading,
  ] = useState(false);

  useEffect(() => {
    getTradingBooksStatus();
    getApplyRemainingOptionStatus();
    getTraceApplyRemainingOptionStatus();
    getPortfoStatus();
  }, []);

  const getPortfoStatus = () => {
    getProgressByType(ProgressType.UpdatePortfo)
      .then((resp) => {
        setPortfoStatus(resp);
        refreshActiveTable();
      })
      .catch(packetErrorHandler)
      .finally(() => {
        setPortfoStatusLoading(false);
      });
  };

  const updatePortfoStatusHandler = () => {
    setPortfoStatusLoading(true);
    updatePortfoStatus()
      .then((resp) => {
        if (resp.data) getPortfoStatus();
        else toast.error(resp.msg);
      })
      .catch((error) => {
        packetErrorHandler(error);
        setPortfoStatusLoading(false);
      });
  };

  const getTradingBooksStatus = () => {
    getProgressByType(ProgressType.UpdateApplyPlan)
      .then((resp) => {
        setTradingBooksStatus(resp);
        refreshActiveTable();
      })
      .catch(packetErrorHandler)
      .finally(() => {
        setTradingBooksStatusLoading(false);
      });
  };

  const updateTradingBooksStatusHandler = () => {
    setTradingBooksStatusLoading(true);
    updateTradingBooksStatus()
      .then((resp) => {
        if (resp.data) getTradingBooksStatus();
        else toast.error(resp.msg);
      })
      .catch((error) => {
        packetErrorHandler(error);
        setTradingBooksStatusLoading(false);
      });
  };

  const getApplyRemainingOptionStatus = () => {
    getProgressByType(ProgressType.RemainingRequests)
      .then((resp) => {
        setApplyRemainingOptionStatus(resp);
        refreshActiveTable();
      })
      .catch(packetErrorHandler)
      .finally(() => {
        setApplyRemainingOptionStatusLoading(false);
      });
  };

  const updateApplyRemainingOptionStatusHandler = () => {
    setApplyRemainingOptionStatusLoading(true);

    submitApplyRemainingOptionRequest()
      .then((resp) => {
        if (resp.data) getApplyRemainingOptionStatus();
        else toast.error(resp.msg);
      })
      .catch((error) => {
        packetErrorHandler(error);
        setApplyRemainingOptionStatusLoading(false);
      });
  };

  const getTraceApplyRemainingOptionStatus = () => {
    getProgressByType(ProgressType.CheckRequests)
      .then((resp) => {
        setTraceAppliedRemainingOptionStatus(resp);
        refreshActiveTable();
      })
      .catch(packetErrorHandler)
      .finally(() => {
        setTraceAppliedRemainingOptionStatusLoading(false);
      });
  };

  const updateTraceApplyRemainingOptionStatusHandler = () => {
    setTraceAppliedRemainingOptionStatusLoading(true);

    traceAppliedRemainingOptionRequest()
      .then((resp) => {
        if (resp.data) getTraceApplyRemainingOptionStatus();
        else toast.error(resp.msg);
      })
      .catch((error) => {
        packetErrorHandler(error);
        setTraceAppliedRemainingOptionStatusLoading(false);
      });
  };

  const getBtnWithTextJSX = (
    time: string,
    text: string,
    event: () => void,
    loading: boolean,
  ) => (
    <div className="flex flex-col justify-center items-center gap-2">
      <div className="text-xs">
        آخرین زمان {text}: {time}
      </div>
      <div className="w-min">
        <Button
          text={text}
          loading={loading}
          disabled={loading}
          onClick={event}
          variant="contained"
        />
      </div>
    </div>
  );

  return (
    <div className="w-full px-6 py-3 flex flex-row justify-between items-center border border-gray-400 rounded">
      {getBtnWithTextJSX(
        portfoStatus.lastStatusTime,
        "دریافت پورتفو",
        updatePortfoStatusHandler,
        portfoStatusLoading,
      )}
      {getBtnWithTextJSX(
        tradingBooksStatus.lastStatusTime,
        "آپدیت برنامه اعمال",
        updateTradingBooksStatusHandler,
        tradingBooksStatusLoading,
      )}
      {getBtnWithTextJSX(
        applyRemainingOptionStatus.lastStatusTime,
        "درخواست اعمال باقی مانده",
        updateApplyRemainingOptionStatusHandler,
        applyRemainingOptionStatusLoading,
      )}
      {getBtnWithTextJSX(
        traceAppliedRemainingOptionStatus.lastStatusTime,
        "بررسی اعمال های ثبت شده",
        updateTraceApplyRemainingOptionStatusHandler,
        traceAppliedRemainingOptionStatusLoading,
      )}
    </div>
  );
};

export default StatusesBox;
